<template>
    <div class="header">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i v-if="!collapse" class="el-icon-s-fold"></i>
            <i v-else class="el-icon-s-unfold"></i>
        </div>
        <div style="float: left;height: 100%;display: flex;align-items: center;margin: 0px 35px">
            <img :src="userData.pc_logo" alt="" style="max-width: 160px">
        </div>
        <!--        <div style="float: left;height: 100%;display: flex;align-items: center;margin: 0px 35px">-->
        <!--            <img src="../../assets/img/wyb_logo.png" alt="" style="max-width: 75px">-->
        <!--        </div>-->
        <div class="logo">案件管理系统
            <span style="font-size: 14px;font-weight: 600;margin-left: 20px">企业端</span>
        </div>
        <div class="header-right">
            <div class="header-user-con">
<!--              查看可视化数据-->
<!--                <div style="margin-right: 15px;cursor: pointer" @click="goView">-->
<!--                  <el-tooltip effect="dark" content="可视化数据" placement="bottom">-->
<!--                    <i class="el-icon-monitor"></i>-->
<!--                  </el-tooltip>-->
<!--                </div>-->
                <!-- 全屏显示 -->
                <div class="btn-fullscreen" @click="handleFullScreen">
                    <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
                        <i class="el-icon-rank"></i>
                    </el-tooltip>
                </div>
                <!-- 消息中心 -->
                <div class="btn-bell">
                    <router-link to="/insuranceMessage">
                        <i class="el-icon-bell"></i>
                    </router-link>
                    <span class="btn-bell-badge" v-if="message"></span>
                </div>
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        <span>{{information.name}} <span v-if="information.user_type==2">-管理员-</span> <span
                                v-if="information.user_type==3">-员工-</span> <span>{{information.yg_name}}</span> </span>
                        <!--                        <span>{{information.name}}</span>-->
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="pullDownBox">
                        <div class="switchBox">
                            <p>切换身份：</p>
                            <div class="roll">
                                <div v-for="(item,index) in switchIdentity" :key="index" class="changeOver">
                                    <p @click="switchover(item)">{{item.name}}</p>
                                </div>
                            </div>
                        </div>
                        <div @click="individual" class="pullDown" v-if="information.user_type==1">个人中心</div>
                        <div @click="enterprise" class="pullDown"
                             v-if="information.user_type==2||information.user_type==3">企业中心
                        </div>
                        <div class="pullDown" @click="operator" v-if="shenfen.is_operator == 2 && shenfen.user_type != 3">运营商中心</div>
                        <div @click="remove" class="pullDown">退出登录</div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>
<script>
    import bus from '../common/bus';
    import { membership, personalDetails, switchIdentity } from '../../api/personal';
    import { unreadNum } from '../../api/insure';

    export default {
        inject: ['reload'],

        data() {
            return {
                collapse: false,
                fullscreen: false,
                name: 'admin',
                message: 2,
                real_name: '',
                company_id: '',
                information: '',
                switchIdentity: '',
                identity: '',
                logoImg: '',
                userData: '',
                shenfen:''
            };
        },
        computed: {
            username() {
                let username = localStorage.getItem('ms_username');
                return username ? username : this.name;
            }
        },
        methods: {
            // 用户名下拉菜单选择事件
            handleCommand(command) {
                if (command == 'loginout') {
                    localStorage.removeItem('ms_username');
                    // this.$router.push('/login');
                }
            },
            // 侧边栏折叠
            collapseChage() {
                this.collapse = !this.collapse;
                bus.$emit('collapse', this.collapse);
            },
            // 查看可视化数据
            goView(){
                this.$router.push('/visualization');
            },
            // 全屏事件
            handleFullScreen() {
                let element = document.documentElement;
                if (this.fullscreen) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.webkitRequestFullScreen) {
                        element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.msRequestFullscreen) {
                        // IE11
                        element.msRequestFullscreen();
                    }
                }
                this.fullscreen = !this.fullscreen;
            },
            remove() {
                // sessionStorage.removeItem('token');
                // sessionStorage.removeItem('shenfen');
                sessionStorage.clear();
                this.$router.push('/login');
            },
            //切换身份
            switchover(item) {
                sessionStorage.setItem('shenfen', JSON.stringify(item));
                this.$message.success('切换成功');
                switchIdentity().then(res => {

                });
                this.$router.push({ path: '/index' });
                this.reload();
            },
            //切换个人中心
            individual() {
                this.$router.push('/personalCenter');
            },
            //企业中心
            enterprise() {
                this.$router.push('/enterpriseCenter');
            },
            // 运营商
            operator(){
                this.$router.push('/operatorCenter');
            }
        },
        mounted() {
            if (document.body.clientWidth < 1500) {
                this.collapseChage();
            }
        },
        created() {
            this.logoImg = JSON.parse(localStorage.getItem('logo'));
            this.userData = JSON.parse(localStorage.getItem('userData'));
            //个人信息
            membership().then(res => {
                if (!sessionStorage.getItem('shenfen')) {
                    if (res.data.last_identity) {
                        sessionStorage.setItem('shenfen', JSON.stringify(res.data.last_identity));
                        this.information = res.data.last_identity;
                    } else {
                        sessionStorage.setItem('shenfen', JSON.stringify(res.data.identity[0]));
                        this.information = res.data.identity[0];
                    }
                } else if (sessionStorage.getItem('shenfen')) {
                    var identity = JSON.parse(sessionStorage.getItem('shenfen'));
                    this.information = identity;
                }
                this.shenfen = JSON.parse(sessionStorage.getItem('shenfen'))
                // this.switchIdentity=res.data.identity
                this.switchIdentity = res.data.identity.filter((item) => {
                    return item.name != JSON.parse(sessionStorage.getItem('shenfen')).name;
                });
            });
            //未读消息数量
            unreadNum().then(res => {
                if (res.code == 200) {
                    this.message = res.data.num;
                } else {
                    this.$message.error(res.msg);
                }
            });
            //个人信息展示
            // personalDetails().then(res=>{
            //     // config.headers['identity']
            //     var arr=res.data.identity
            //     var arr2=arr.slice(0,1)
            //     arr2.map((item)=>{
            //         console.log(item);
            //         sessionStorage.setItem('Comid',item.com_id)
            //     })
            //     this.switchIdentity=res.data.identity
            //     this.information=res.data
            //     this.company_id=res.data.company_id
            // })


        }
    };
</script>
<style scoped lang="less">
    .header {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 70px;
        font-size: 22px;
        color: #fff;
        background-color: #2350b5;
    }

    .collapse-btn {
        float: left;
        padding: 0 21px;
        cursor: pointer;
        line-height: 70px;
    }

    .header .logo {
        float: left;
        width: 250px;
        line-height: 70px;
    }

    .header-right {
        float: right;
        padding-right: 50px;
    }

    .header-user-con {
        display: flex;
        height: 70px;
        align-items: center;
    }

    .btn-fullscreen {
        transform: rotate(45deg);
        margin-right: 5px;
        font-size: 24px;
    }

    .btn-bell,
    .btn-fullscreen {
        position: relative;
        width: 30px;
        height: 30px;
        text-align: center;
        border-radius: 15px;
        cursor: pointer;
    }

    .btn-bell-badge {
        position: absolute;
        right: 0;
        top: -2px;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #f56c6c;
        color: #fff;
    }

    .btn-bell .el-icon-bell {
        color: #fff;
    }

    .user-name {
        margin-left: 10px;
    }

    .user-avator {
        margin-left: 20px;
    }

    .user-avator img {
        display: block;
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }

    .el-dropdown-link {
        color: #fff;
        cursor: pointer;
    }

    .el-dropdown-menu__item {
        text-align: center;
    }

    .pullDown {
        padding: 5px 0px;
        font-size: 14px;
        margin: 10px 10px;
        text-align: center;
        color: #262626;
        cursor: pointer;
    }

    .pullDownBox {
        width: 300px;
    }

    .pullDown:hover {
        background-color: #f6f6f6;
    }

    .switchBox {
        margin: 5px 20px;
        color: #262626;
        font-size: 14px;
    }

    .switchBox p {
        width: 100%;
        padding: 5px 0px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
    }

    .switchBox p:hover {
        background-color: #f6f6f6;
    }

    .changeOver > p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .changeOver > p:hover {
        color: #1063f1;
    }

    .switchBox > p {
        margin-bottom: 10px;
    }

    .roll {
        max-height: 150px;
        min-height: 30px;
        overflow-y: scroll;

        &::-webkit-scrollbar {
            width: 5px;
            height: 4px;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 5px;
            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background-color: #CACDD1;
        }
    }

</style>
